import React, { useState } from 'react';
import { CalendarClock, ChevronDown } from 'lucide-react';
import ProductionForecastCard from './ProductionForecastCard';

export default function ProductionForecastAccordion(props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="overflow-hidden rounded-xl border border-indigo-100 bg-indigo-50/60 dark:border-indigo-900 dark:bg-indigo-950/20">
      <button
        type="button"
        onClick={() => setOpen(value => !value)}
        aria-expanded={open}
        className="flex w-full items-center gap-2 px-3 py-3 text-left text-indigo-950 transition-colors hover:bg-indigo-100/60 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 dark:text-indigo-100 dark:hover:bg-indigo-900/20"
      >
        <CalendarClock className="h-4 w-4 shrink-0 text-indigo-600 dark:text-indigo-300" />
        <span className="min-w-0 flex-1 text-sm font-semibold">Ориентировочные сроки</span>
        <ChevronDown className={`h-5 w-5 shrink-0 text-indigo-600 transition-transform dark:text-indigo-300 ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="border-t border-indigo-100 p-3 dark:border-indigo-900">
          <ProductionForecastCard {...props} showHeading={false} embedded />
        </div>
      )}
    </div>
  );
}
